import React from 'react';
import bingebanner from '../../images/img/binge-banner.jpg'
import './FormFieldsStyle.css';

const Banner = (props) => {

    const data= props.item && props.item.data && JSON.parse(props.item.data)
    const img = data && data.image;
    const url= data && data.url;
    const width=data && data.width ;
    const height=data && data.height ;
    
    console.log("bannerprops",data,props);

    return(
        <div class="chat-wrapp flex-between">
        <div className="mB10 binge-banner disblock">
           <a href={url} target="_blank" > <img src={img} alt="" className="img-fluid" width={width} height={height} 
           onClick={()=>{props.handleClick(props.item.code);props.setTextOnClick(props.item.text)}}
            /></a> 
        </div>
        </div>
    )

}

export default Banner;